import { cn } from '@seen/ui'
import type { ComponentProps, JSX } from 'react'
import { CommandLink } from '#src/components/core/Command.tsx'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

export function CommandMenuLink({
  className,
  onSelect,
  ...etc
}: Omit<ComponentProps<typeof CommandLink>, 'onSelect'> & {
  onSelect?: ComponentProps<typeof CommandLink>['onSelect']
}): JSX.Element {
  const setOpen = usePortalStore((state) => state.setCommandMenuOpen)
  return (
    <CommandLink
      onSelect={(...args) => {
        // Don't close the menu if the user is opening the link in a new tab.
        const mouseEvent = args[1]
        if (mouseEvent?.metaKey || mouseEvent?.ctrlKey) {
          return
        }
        setOpen(false)
        onSelect?.(...args)
      }}
      className={cn(
        'flex h-14 items-center px-5 data-[selected=true]:after:inset-x-1.5 data-[selected=true]:after:inset-y-0.5',
        className
      )}
      {...etc}
    />
  )
}
